import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { COLOR_GREY_2, COLOR_GREY_6 } from "shared/theme/colors";

export const NumberContainer = styled(Box)<{ bottom?: string | number }>`
  position: absolute;
  bottom: ${({ bottom }) => bottom || "40px"};
  left: -10px;
  display: flex;
  height: 73px;
  width: 65px;
  align-items: center;
  justify-content: flex-start;
  border-radius: 50%;
`;

export const NumberText = styled("p")<{ color?: string }>`
  white-space: nowrap;
  font-size: 120px;
  font-weight: 800;
  font-style: italic;
  letter-spacing: -28px;
  color: transparent;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: ${({ color }) => color || COLOR_GREY_6};
  text-shadow:
    0px 0px 0px ${COLOR_GREY_2},
    0px 0px 2px ${({ color }) => color || COLOR_GREY_6},
    0px 0px 6px ${({ color }) => color || COLOR_GREY_6};
`;
